// src/utils/ageFormat.js
import { calculateAge } from "./dateUtils";

export function ageWithTurning4(dob, locale = (typeof navigator !== "undefined" ? navigator.language : "nl-NL")) {
    const currentAge = calculateAge(dob);
    const fourth = new Date(dob);
    fourth.setFullYear(fourth.getFullYear() + 4);

    // Als kind nog geen 4 is: toon maand + “4”
    if (currentAge < 4) {
        const month = fourth.toLocaleString(locale, { month: "long" }); // bv. "november"
        return {
            text: `(${month} 4)`,
            exactDate: fourth.toLocaleDateString(locale),                 // bv. "4-11-2027"
        };
    }

    // 4 jaar of ouder: alleen de huidige leeftijd
    return {
        text: `(${currentAge})`,
        exactDate: null,
    };
}